import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as usersSelectors from 'app/ducks/users/selectors';
import * as loadingSelectors from 'app/ducks/loading/selectors';
import { IUsersSelector } from 'app/types/selector';

import RenderContent from 'app/components/layout/RenderContent';
import HeaderThin from 'app/components/layout/HeaderThin';

import CollectPaymentTeam from './components/CollectPaymentTeam';
import CollectPaymentClub from './components/CollectPaymentClub';

interface ICollectLayoutProps {
  match: any;
  users: IUsersSelector;
}
function selector(state): any {
  return {
    users: usersSelectors.getUsers(state),
    appReady: loadingSelectors.appReady(state),
  };
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
})) as any)
export default class CollectLayout extends React.Component<
  ICollectLayoutProps,
  {}
> {
  static defaultProps: ICollectLayoutProps = {
    match: undefined,
    users: undefined,
  };

  render(): React.ReactNode {
    return (
      <RenderContent className="my-dashboard-app" match={this.props.match}>
        <div className="row">
          <div className="col">
            <HeaderThin title="Payment Request" divider />
          </div>
        </div>
        <div className="row">
          <div className="col">
            {this.props.users.currentUser.userType === 'team' && (
              <CollectPaymentTeam />
            )}
            {this.props.users.currentUser.userType === 'club' && (
              <CollectPaymentClub />
            )}
          </div>
        </div>
      </RenderContent>
    );
  }
}
